import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  Aangifte,
  AangifteBerekening,
  AangifteRapport, BokkzAlgDataService,
  BokkzIbDataService, Box1Berekening,
  IncomeTaxEntity, OpbouwInkomenBox1
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject, combineLatest} from "rxjs";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overzicht-neg-pga',
  templateUrl: './overzicht-neg-pga.component.html',
  styleUrl: './overzicht-neg-pga.component.scss',
  imports: [
    SharedUiFormControlsModule,
    CommonModule,
    SharedUiDetailsModule
  ]
})
export class OverzichtNegPgaComponent implements OnInit {

  aangifte = {} as Aangifte;
  public incomeTaxEntity = {} as IncomeTaxEntity;

  @Input() partner = new BehaviorSubject<boolean>(false);
  public partnerBoolean = false;

  @Input() aangifteRapport = {} as AangifteRapport;
  @Input() partnerRapport = {} as AangifteRapport;
  @Input() berekening = {} as AangifteBerekening;
  @Input() partnerBerekening = {} as AangifteBerekening;

  berekeningBox1FormGroup = this.fb.group<AangifteBerekening>({});
  berekeningBox1 = {} as AangifteBerekening;

  constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
    this.berekeningBox1FormGroup = this.fb.group<AangifteBerekening>(({
      box1: this.fb.group<Box1Berekening>(({
        opbouwInkomen: this.fb.group<OpbouwInkomenBox1>(({
          negatievePersoonsgebondenAftrek: null as unknown as number,
        } as OpbouwInkomenBox1)),
      } as Box1Berekening)),
    } as AangifteBerekening))
  }

  public ngOnInit(): void {
    combineLatest([this.dataService.incomeTaxEntity, this.partner]).subscribe(
        ([incomeTaxEntity, partner]) => {
          this.partnerBoolean = partner;
          this.berekeningBox1FormGroup.reset();
          if (incomeTaxEntity.aangifte) {
            const aangifte = incomeTaxEntity.aangifte as Aangifte;
            this.aangifte = aangifte;
            this.updateForm()
            this.disableFormGroup(this.berekeningBox1FormGroup);
          }
        }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['aangifteRapport'] || changes['partnerRapport'] || changes['berekening'] || changes['partnerBerekening']) {
      this.updateForm();
    }
  }


  private updateForm() {
    if (this.partnerBoolean) {
      this.berekeningBox1FormGroup.patchValue(this.partnerBerekening)
    } else {
      this.berekeningBox1FormGroup.patchValue(this.berekening)
    }
  }

  disableFormGroup(formGroup: FormGroup | AbstractControl): void {
    if (formGroup instanceof FormGroup) {
      Object.keys(formGroup.controls).forEach((key) => {
        const control = formGroup.get(key);
        if (control instanceof FormControl) {
          control.disable();
        } else if (control instanceof FormGroup) {
          this.disableFormGroup(control);
        }
      });
    }
  }

}

